const angular = require('angular');

const ShopperService = require('./shopper.service');
const ShopperAnalyticsService = require('./analytics/shopper-analytics.service');
const { shopperAccessibilityComponentDefinition } = require('./shopperaccessibility.component');

angular.module('wowApp.auth')
    .service('ShopperService', ['Restangular', 'BootstrapService', 'ShopperAnalyticsService', ShopperService])
    .service('ShopperAnalyticsService', ['AnalyticsService', ShopperAnalyticsService])
    .component('wowShopperAccessibility', shopperAccessibilityComponentDefinition);



// WEBPACK FOOTER //
// ./src/auth/shopper/index.js